module.exports = __webpack_public_path__ + "static/luton-van-d6965705a04a33e22fdd487e5f53223e.jpg";